export default "__VITE_ASSET__xi46RAND__"